export default __webpack_public_path__ + "static/media/google_analytics_logo.b61ae084.png";